import React from "react";

export default function Loader(props) {
    return (
        <div className="loader-parent row">
            <div className="loader"></div>
            {props.showText !== false ? <span className="h3">{props.text !== undefined ? props.text : "Loading..."}</span> : null}
        </div>
    );
}